// ── 연차 창: 급여 계산 칸을 바꿀 때 같이 맞추는 칸 (2026-10-01 사용자) ─────────────────────
//   "급여 영향 없음" = 이름대로 아무 영향 없음. 그래서 고르는 순간(유급·무급 상관없이)
//     잔여연차 '반영 안 함' · 월차 발생 '영향 없음' · 주휴수당 '영향 없음' 으로 맞춘다. 그 뒤엔 각 칸을 직접 바꿀 수 있다.
//   "급여 영향 없음" 에서 다른 값으로 돌리면 잔여연차·월차는 종류·구분 기본값으로, 주휴는 '공제 대상' 으로 되돌린다
//     — 안 그러면 일반 연차가 잔여연차를 안 깎는 상태로 몰래 남는다(검토에서 발견: 실제로 왕복한 기록이 있었다).
//   급여 계산 쪽(api/services/leave-neutral-day.js)도 같은 날을 결근·주휴공제에서 뺀다.
//   잔여연차 조정 기록(정산·생성·포상·정정)은 날짜 휴가가 아니라 건드리지 않고, 주휴 칸도 안 보인다.
import { inferEffectDefaults } from './utils';

export const BALANCE_ADJUST_TYPES = new Set(['정산', '생성', '포상', '정정', '자동생성']);

/** 급여 계산 칸을 next 로 바꿀 때 updateFormWithRules 에 넘길 값 */
export function payrollEffectPatch(form, next) {
  const patch = { payroll_effect: next, event_type_id: '', event_name: '' };
  if (BALANCE_ADJUST_TYPES.has(String(form?.type || ''))) return patch;
  if (next === 'none') {
    return { ...patch, leave_balance_effect: 'none', monthly_grant_effect: 'neutral', affects_weekly_holiday: false };
  }
  if (form?.payroll_effect === 'none') {
    const d = inferEffectDefaults(form.type, form.category);
    return { ...patch, leave_balance_effect: d.leave_balance_effect, monthly_grant_effect: d.monthly_grant_effect, affects_weekly_holiday: true };
  }
  return patch;
}

/**
 * 유형 템플릿을 고를 때 주휴 값 — 템플릿 표에는 주휴 칸이 없다(DB 구조 변경 금지).
 *   템플릿이 '급여 영향 없음' 이면 주휴도 '영향 없음', '급여 영향 없음' 에서 다른 템플릿으로 옮기면 '공제 대상' 으로.
 *   그 밖에는 손대지 않는다(무급 '주휴 영향 없음' 을 쓰는 기존 흐름 그대로).
 * @returns {{affects_weekly_holiday?: boolean}}
 */
export function eventTypeWeeklyPatch(form, selected) {
  if (BALANCE_ADJUST_TYPES.has(String(selected?.type || form?.type || ''))) return {};
  if (selected?.payroll_effect === 'none') return { affects_weekly_holiday: false };
  if (form?.payroll_effect === 'none') return { affects_weekly_holiday: true };
  return {};
}

/** 주휴수당 영향 칸을 보일지 — 무급 공제·급여 영향 없음일 때(유급 인정은 계산이 늘 주휴를 유지해 고를 의미가 없다) */
export function showsWeeklyHolidayField(form) {
  if (BALANCE_ADJUST_TYPES.has(String(form?.type || ''))) return false;
  return form?.payroll_effect === 'unpaid_absence' || form?.payroll_effect === 'none';
}
